import React, { useMemo } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { JsonForms } from '@jsonforms/react'

import { materialCells } from '@jsonforms/material-renderers'
import DynamicWrapper from 'designer/component/system/layout/control/DynamicWrapper'
import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'

import {
  createSwitchRenderer,
  createDisplayRenderer,
} from 'designer/component/control/renderer'

export const DynamicSystemPanel = (props) => {
  let { data, schema, uischema, config } = props
  const { isFirstElement, isSample = false } = config
  const renderers = useMemo(
    () => createSwitchRenderer(uischema.elements, isFirstElement),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <>
      {isSample ? (
        <ComponentWrapper {...props}>
          <JsonForms
            schema={schema}
            uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
            data={data}
            renderers={renderers}
            cells={materialCells}
            config={{
              ...config,
              isDynamic: true,
            }}
          />
        </ComponentWrapper>
      ) : (
        <DynamicWrapper {...props} isFirstElement={isFirstElement}>
          <JsonForms
            schema={schema}
            uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
            data={data}
            renderers={renderers}
            cells={materialCells}
            config={{
              ...config,
              isDynamic: true,
            }}
          />
        </DynamicWrapper>
      )}
    </>
  )
}

export const SubDynamicSystemPanel = (props) => {
  let { data, schema, uischema, config } = props
  const { isFirstElement, isSample = false } = config

  const renderers = useMemo(
    () => createSwitchRenderer(uischema.elements, isFirstElement),
    [JSON.stringify(uischema.elements)]
  )
  return (
    <>
      {isSample ? (
        <ComponentWrapper {...props}>
          <JsonForms
            schema={schema}
            uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
            data={data}
            renderers={renderers}
            cells={materialCells}
            config={{
              ...config,
              isDynamic: true,
            }}
          />
        </ComponentWrapper>
      ) : (
        <DynamicWrapper {...props} isFirstElement={isFirstElement}>
          <JsonForms
            schema={schema}
            uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
            data={data}
            renderers={renderers}
            cells={materialCells}
            config={{
              ...config,
              isDynamic: true,
            }}
          />
        </DynamicWrapper>
      )}
    </>
  )
}

export const DynamicDisplayPanel = (props) => {
  let { data, schema, uischema, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [uischema.key]
  )

  return (
    <ComponentWrapper {...props}>
      <JsonForms
        schema={schema}
        uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </ComponentWrapper>
  )
}

export const SubDynamicDisplayPanel = (props) => {
  let { data, schema, uischema, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [uischema.key]
  )

  return (
    <ComponentWrapper {...props}>
      <JsonForms
        schema={schema}
        uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
        data={data}
        renderers={renderers}
        cells={materialCells}
        config={{
          ...config,
          isDynamic: true,
        }}
      />
    </ComponentWrapper>
  )
}

export const dynamicPanelTester = rankWith(3, scopeEndsWith('dynamicPanel'))

export const dynamicPanelSystem = {
  tester: dynamicPanelTester,
  renderer: withJsonFormsControlProps(DynamicSystemPanel),
}

export const subDynamicPanelSystem = {
  tester: dynamicPanelTester,
  renderer: withJsonFormsControlProps(SubDynamicSystemPanel),
}

export const dynamicPanelDisplay = {
  tester: dynamicPanelTester,
  renderer: withJsonFormsControlProps(DynamicDisplayPanel),
}

export const subDynamicPanelDisplay = {
  tester: dynamicPanelTester,
  renderer: withJsonFormsControlProps(SubDynamicDisplayPanel),
}
